import { Badge, Box, Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import MainLoader from '../Loader';
import styles from './index.module.css';

const PdfViewer = ({ opened, close, modalTitle, url }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);

  useEffect(() => {
    setPageNumber(1);
  }, [url]);

  const incrementPageNumber = () => {
    setPageNumber(value => (value >= numPages ? numPages : value + 1));
  };

  const decrementPageNumber = () => {
    setPageNumber(value => (value <= 1 ? 1 : value - 1));
  };

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
    setIsLoading(false);
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={modalTitle}
      zIndex={205}
      size="80%"
      centered
    >
      <Stack className={styles.container}>
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<MainLoader />}
        >
          <Page pageNumber={pageNumber} />
        </Document>
      </Stack>
      <Group className={styles.pagination} align="center" justify="center">
        <Button
          variant="primary"
          size="md"
          radius="sm"
          onClick={decrementPageNumber}
          disabled={pageNumber <= 1}
        >
          -
        </Button>
        <Button
          variant="primary"
          size="md"
          radius="sm"
          onClick={incrementPageNumber}
          disabled={pageNumber >= numPages}
        >
          +
        </Button>
        <Badge bg="primary" p="lg" radius="sm">
          <Text>
            {pageNumber} / {numPages}
          </Text>
        </Badge>
      </Group>
    </Modal>
  );
};

export default PdfViewer;
